module.exports = "https://static.wmbcdn.com/uniweb/images/e85cadbe628056b425660b85f162caae.svg";